import { Link } from 'react-router-dom';
import {
    PiAppStoreLogoDuotone,
    PiArrowDownDuotone,
    PiArrowRightDuotone,
    PiGooglePlayLogoDuotone,
} from 'react-icons/pi';

import Noise from 'elements/Noise';
import Pattern from 'elements/Pattern';
import { mekiJobAreas } from 'data/mekiPages';

const experienceCards = [
    {
        title: 'Ismerd meg a Mekizés örömét!',
        text: 'Számos indokunk van, amiért Mekisnek lenni jó',
        image: '/assets/images/meki_content_5.jpg',
        to: '/miert-jo-a-meki-diakmunka',
    },
    {
        title: 'Ismerd meg a Fürge Mekis csapatát!',
        text: 'Számunkra ez nem csak munka, hanem otthon, család és barátság',
        image: '/assets/images/meki_content_6.jpg',
        to: '/mi-mekisek',
    },
];

export default function MekiMainPage() {
    const scrollToContent = () => {
        document.getElementById('meki-elmenyek')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    return (
        <main className='w-full bg-white/20'>
            <section className='relative z-20 min-h-[calc(100svh-5rem)] overflow-hidden rounded-b-3xl shadow-2xl isolate'>
                <img
                    src='/assets/images/background/meki_main.jpg'
                    alt='Fiatalok egy összetartó közösségben'
                    className='absolute inset-0 size-full object-cover object-center'
                />
                <div className='absolute inset-0 bg-gradient-to-t from-red-950 via-red-950/60 to-red-950/15 md:bg-gradient-to-r md:from-red-950/95 md:via-red-950/45 md:to-red-950/10' />
                <Noise />

                <div className='relative z-10 mx-auto flex min-h-[calc(100svh-5rem)] w-full max-w-boxed items-center px-site py-20'>
                    <div className='flex max-w-4xl flex-col items-center text-center md:items-start md:text-left'>
                        <h1 className='font-display text-4xl font-black leading-[0.98] text-white text-balance sm:text-6xl lg:text-7xl xl:text-8xl'>
                            A Mekis diákmunka <span className='text-yellow-400'>közösséget teremt</span>
                        </h1>
                        <p className='mt-6 max-w-3xl text-base leading-relaxed text-white/85 sm:text-lg lg:text-xl'>
                            Olyan diákmunkát keresel, ahol jó a hangulat, tudsz fejlődni és rugalmas az időbeosztás? A Meki közössége téged is vár! Találd meg a hozzád legközelebbi éttermek diákmunka ajánlatait!
                        </p>
                        <div className='mt-8 flex w-full flex-col items-stretch gap-3 sm:w-auto sm:flex-row'>
                            <Link to='/diakmunka' className='button gradient-green shadow-xl shadow-red-950/20'>
                                Megnézem az állásokat <PiArrowRightDuotone />
                            </Link>
                            <button type='button' onClick={scrollToContent} className='button border border-white/20 bg-red-950/35 backdrop-blur-md hover:bg-red-950/50'>
                                Olvass tovább <PiArrowDownDuotone />
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <section id='meki-elmenyek' className='relative z-10 -mt-6 scroll-mt-20 overflow-hidden rounded-b-3xl bg-gradient-to-br from-red-800 via-red-700 to-red-600 px-site pb-16 pt-20 shadow-2xl sm:pb-20 sm:pt-24'>
                <Pattern />
                <div className='relative z-10 mx-auto flex w-full max-w-boxed flex-col gap-10'>
                    <SectionHeading title='A Mekis diákmunkával élményeket gyűjthetsz' light />

                    <div className='grid grid-cols-1 gap-6 lg:grid-cols-2'>
                        {experienceCards.map((item) => <ExperienceCard key={item.title} item={item} />)}
                    </div>
                </div>
            </section>

            <section className='relative z-0 -mt-6 bg-stone-50 px-site pb-16 pt-28 sm:pb-20 sm:pt-32'>
                <div className='mx-auto flex w-full max-w-boxed flex-col gap-10'>
                    <SectionHeading title='A Mekis diákmunkáról' />

                    <div className='rounded-3xl border border-red-100 bg-white p-6 shadow-xl shadow-red-900/5 sm:p-10 lg:p-12'>
                        <p className='text-sm leading-relaxed text-neutral-700 sm:text-base lg:text-lg'>
                            A Mekiben a csapatmunka az első, és tudnod kell, hogy soha nem vagy egyedül. Mind a Meki mentor programja, mind a Fürge Diák Mekis csapata ott áll mellett, ha kérdésed adódik vagy segítségre van szükséged. Az étteremben folyamatos támogatással tanulod meg az egyes munkafolyamatokat, és rövid idő alatt magabiztosan mozogsz majd az egész étteremben.
                        </p>
                        <p className='mt-5 text-sm leading-relaxed text-neutral-700 sm:text-base lg:text-lg'>
                            A Mekis diákmunka pörgős. Nincs idő lustálkodásra, de szükség van az önállóságra. A csapat csak úgy tudja kiszolgálni a vendégeket, ha mindenki felelősséggel végzi el a rá bízott feladatokat. És bár diákmunkát vállalsz, ugyanolyan Mekis leszel, mint bárki más. A Meki nem tesz különbséget diák és nem diák között. Felnőttként tekintenek rád, és az elvárások is eszerint alakulnak.
                        </p>
                        <p className='mt-5 font-display text-xl font-black text-red-700 sm:text-2xl'>
                            Érdekel a kihívás? Ismerd meg diákmunka ajánlatainkat!
                        </p>
                    </div>
                </div>
            </section>

            <section className='relative overflow-hidden bg-black/40 px-site py-16 sm:py-24'>
                <Pattern />
                <div className='relative z-10 mx-auto w-full max-w-boxed'>
                    <div className='grid grid-cols-1 gap-6 sm:grid-cols-2 xl:grid-cols-4'>
                        {mekiJobAreas.map((item) => <JobAreaCard key={item.key} item={item} />)}
                    </div>
                </div>
            </section>

            <section className='relative overflow-hidden rounded-t-3xl bg-gradient-to-br from-yellow-400 via-amber-400 to-lime-500 px-site py-16 shadow-2xl sm:py-24'>
                <Noise />
                <div className='relative z-10 mx-auto grid w-full max-w-boxed grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16'>
                    <div className='order-2 overflow-hidden rounded-3xl bg-white/20 p-2 shadow-2xl ring-1 ring-white/40 lg:order-1'>
                        <img src='/assets/images/meki_content_4.jpg' alt='A Fürge Drive alkalmazás bemutatója' className='aspect-[4/3] size-full rounded-[1.25rem] object-cover' />
                    </div>
                    <div className='order-1 flex flex-col items-center text-center lg:order-2 lg:items-start lg:text-left'>
                        <h2 className='font-display text-3xl font-black leading-tight text-neutral-900 text-balance sm:text-4xl xl:text-5xl'>Egy APP a Mekis diákmunkáról a Fürge Diákoknak</h2>
                        <h3 className='mt-5 font-display text-xl font-black text-red-800 sm:text-2xl lg:text-3xl'>Töltsd le a Fürge Drive-ot ingyen!</h3>
                        <p className='mt-4 max-w-2xl text-base leading-relaxed text-neutral-800 sm:text-lg'>
                            Applikációnkkal napra kész leszel a Meki tananyagait tekintve, és eljuttatjuk hozzád a legfrissebb Mekis infókat is. Készen állsz a Mekizésre? Akkor szerezd be az appot is!
                        </p>
                        <div className='mt-8 flex w-full flex-col gap-3 sm:w-auto sm:flex-row'>
                            <a href='https://play.google.com/store/apps/details?id=hu.humania.mcfurge.app.android&hl=hu' target='_blank' rel='noreferrer' className='button gradient-red shadow-lg'>
                                <PiGooglePlayLogoDuotone /> Irány a Google Play
                            </a>
                            <a href='https://apps.apple.com/us/app/f%C3%BCrge-drive/id1453177979' target='_blank' rel='noreferrer' className='button gradient-red shadow-lg'>
                                <PiAppStoreLogoDuotone /> Irány az App Store
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}

function SectionHeading({ title, light = false }) {
    return (
        <h2 className={'max-w-5xl font-display text-3xl font-black leading-tight text-balance sm:text-4xl lg:text-5xl xl:text-6xl ' + (light ? 'text-yellow-300' : 'text-red-700')}>
            {title}
        </h2>
    );
}

function ExperienceCard({ item }) {
    return (
        <Link to={item.to} className='group relative min-h-80 overflow-hidden rounded-3xl bg-red-950 shadow-2xl ring-1 ring-white/20 sm:min-h-96'>
            <img src={item.image} alt='' className='absolute inset-0 size-full object-cover transition duration-700 group-hover:scale-105' />
            <div className='absolute inset-0 bg-gradient-to-t from-red-950 via-red-950/25 to-transparent' />
            <div className='absolute inset-x-0 bottom-0 flex items-end justify-between gap-5 p-6 sm:p-8'>
                <div>
                    <h3 className='font-display text-2xl font-black leading-tight text-yellow-300 sm:text-3xl'>{item.title}</h3>
                    <p className='mt-2 max-w-xl text-sm leading-relaxed text-white/80 sm:text-base'>{item.text}</p>
                </div>
                <span className='flex size-12 shrink-0 items-center justify-center rounded-2xl bg-red-600 text-white shadow-lg transition group-hover:translate-x-1 group-hover:bg-lime-600'>
                    <PiArrowRightDuotone className='size-6' />
                </span>
            </div>
        </Link>
    );
}

function JobAreaCard({ item }) {
    return (
        <Link to={`/munkakor?key=${item.key}`} className='group overflow-hidden rounded-3xl bg-white shadow-2xl shadow-red-900/10 transition duration-500 hover:-translate-y-2'>
            <div className='relative aspect-[4/3] overflow-hidden'>
                <img src={item.image} alt='' className='size-full object-cover transition duration-700 group-hover:scale-105' />
                <div className='absolute inset-x-0 bottom-0 bg-gradient-to-t from-red-950/75 to-transparent p-5 pt-14'>
                    <div className='flex items-center justify-between gap-3 text-sm font-bold text-white'>
                        Kattints a részletekért! <PiArrowRightDuotone className='size-5 shrink-0' />
                    </div>
                </div>
            </div>
            <div className='p-6'>
                <h3 className='font-display text-2xl font-black leading-tight text-red-700'>{item.title}</h3>
                <p className='mt-3 text-sm leading-relaxed text-neutral-600'>{item.text}</p>
            </div>
        </Link>
    );
}
